exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styled-date-in-opening-detail {\n  display: inherit;\n  width: 28%;\n}\n", ""]);

// exports
